import { objectParticle, subjectParticle, topicParticle } from './korean';

/**
 * 화면이 **틀린 이름으로** 칸을 요구하는 자리.
 *
 * 인사등록 자격증 탭은 자격증번호가 비면 `필수입력확인: 교육기관을 입력하십시오` 라고
 * 말한다. 교육기관(`orgnm`)은 **교육 탭의 열**이고 자격증 탭에는 없다 — 그 탭에서
 * 「교육기관」에 해당하는 칸은 발생기관(`licencewhere`)인데, 그것을 채워도 같은 문구가
 * 그대로 나온다. `필수입력확인` 은 서버(PB)가 내는 문구라 화면 코드에서 못 고친다.
 *
 * 실측(2026-09-01, weberp, 저장 세 판):
 *
 * | licence | licencewhere | licencenum | licenceday1 | 결과 |
 * |---|---|---|---|---|
 * | ✅ | ✅ | ❌ | ❌ | 교육기관을 입력하십시오 |
 * | ✅ | ✅ | ✅ | ✅ | 저장됨 |
 * | ✅ | ✅ | ❌ | ✅ | 교육기관을 입력하십시오 |
 *
 * 갈린 칸은 `licencenum` 하나다. 그래서 화면이 「교육기관」이라 말하면 **자격증번호**로
 * 읽는다. 이 표를 좁게 유지한다 — 넓히면 멀쩡한 화면의 말을 우리가 왜곡한다.
 */
export const MISLABELED: { route: RegExp; tab?: RegExp; said: string; means: string }[] = [
  { route: /w_p2110/, tab: /자격증/, said: '교육기관', means: '자격증번호' },
];

/**
 * 틀린 이름을 알림 문구 자체에서 바꾼다.
 *
 * 요구 칸만 고치면 사람에게 나가는 말은 여전히 「교육기관을 입력하십시오」다 — 그 탭에
 * 없는 칸을 사람에게 물어보게 된다. 한 자리에서 고쳐 양쪽이 같은 이름을 쓰게 한다.
 */
export function correctNotices(notices: string[], route: string, tab?: string): string[] {
  const hits = MISLABELED.filter((one) => one.route.test(route)
    && (!one.tab || (tab ? one.tab.test(tab) : false)));
  if (!hits.length) return notices;
  // **조사까지 갈아 준다.** 그냥 바꾸면 `자격증번호을 입력하십시오` 가 된다 —
  // 받침이 있는 「교육기관」 자리에 받침 없는 이름이 들어가기 때문이다.
  return notices.map((notice) => hits.reduce((text, one) => {
    const particled = new RegExp(`${one.said}(을|를|이|가|은|는)`, 'g');
    return text
      .replace(particled, (_all, particle) => swap(one.means, particle))
      .split(one.said)
      .join(one.means);
  }, notice));
}

/**
 * 앞말이 바뀌었으니 조사도 그 말에 맞춘다. 짝을 유지한다 — 목적격은 목적격으로.
 *
 * `objectParticle` 류는 **낱말까지 붙여서** 돌려준다. 앞에 이름을 또 붙이면
 * `자격증번호자격증번호를` 이 된다.
 */
function swap(word: string, particle: string): string {
  if (particle === '을' || particle === '를') return objectParticle(word);
  if (particle === '이' || particle === '가') return subjectParticle(word);
  return topicParticle(word);
}
